import log from "../utils/logger/library";

let localforage = {
    setItem: () => {
        return Promise.reject("weeeeee");
    },
    getItem: () => {
        return Promise.reject("woooooo");
    },
};

const init = () => {
    localforage = require("localforage");
    // Use this driver order
    localforage.config({
        driver: [
            localforage.INDEXEDDB,
            localforage.WEBSQL,
            localforage.LOCALSTORAGE,
        ],
        name: "cbc_storage",
        storeName: "cbc_storage",
        version: 1.0,
        description: "storage for cbc site",
    });
};

export const setup = (state = {}) => {
    init();
    return localforage
        .getItem("region")
        .then((region) => {
            if (region) {
                state.regions = {
                    selected: region,
                };
            }
        })
        .catch((error) => {
            log.error("(setup) localforage error", error);
        });
};

export const setItem = (key, value) => {
    return localforage.setItem(key, value);
};

export const getItem = (key) => {
    return localforage.getItem(key);
};
